// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"04b6b4e6","133":"160c8e1c","172":"bc2e03be","339":"a5e8b5c7","341":"f758ec0e","433":"e26fae10","453":"154b9e80","706":"a1ff536d","882":"1eac7466"}[chunkId] + ".chunk.js";
};